var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCercTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.668,
    height: 50,
    viewBox: "0 0 36.668 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cerc-timeline",
    transform: "translate(-4109.166 -2756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-11946.5,8570.992a4.969,4.969,0,0,1-3.5-1.432l-14.831-14.561h36.668l-14.831,14.561A4.969,4.969,0,0,1-11946.5,8570.992Z",
    transform: "translate(16074 -5799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(4117 2785)",
    fill: "#060020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_16_-_Outline",
    "data-name": "Ellipse 16 - Outline",
    d: "M10.5,4A6.5,6.5,0,1,0,17,10.5,6.507,6.507,0,0,0,10.5,4m0-4A10.5,10.5,0,1,1,0,10.5,10.5,10.5,0,0,1,10.5,0Z",
    transform: "translate(4117 2785)",
    fill: "#34ffc8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCercTimeline);
export default __webpack_public_path__ + "static/media/cerc-timeline.ea5054314183364bc83cc4b85776f726.svg";
export { ForwardRef as ReactComponent };